import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/** Финансирование по годам */
let PitActivityFinancingAmount = class PitActivityFinancingAmount {
    get year() {
        return this._year;
    }
    set year(value) {
        this._year = value;
    }
    get budgetLevelId() {
        return this._budgetLevelId;
    }
    set budgetLevelId(value) {
        this._budgetLevelId = value;
    }
    get financingSum() {
        return this._financingSum;
    }
    set financingSum(value) {
        this._financingSum = value;
    }
    get normTypeId() {
        return this._normTypeId;
    }
    set normTypeId(value) {
        this._normTypeId = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "year", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityFinancingAmount.prototype, "_year", void 0);
tslib_1.__decorate([
    jsonMember({ name: "budgetLevelId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityFinancingAmount.prototype, "_budgetLevelId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "financingSum", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityFinancingAmount.prototype, "_financingSum", void 0);
tslib_1.__decorate([
    jsonMember({ name: "normTypeId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityFinancingAmount.prototype, "_normTypeId", void 0);
PitActivityFinancingAmount = tslib_1.__decorate([
    jsonObject
], PitActivityFinancingAmount);
export { PitActivityFinancingAmount };
